import {
    AtualizarUsuarioInterface,
    IListaUsuariosTransferencias,
} from "../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import {
    AtualizarUsuarioService,
    DeletarUsuarioService,
    GetUsuarioInfoService,
    ListarUsuariosGrupoService,
    ListarUsuariosMesmoProdutoService,
    ListarUsuariosService,
    ListarUsuariosTransferenciaService,
} from "../../../Services/Geral/GestaoUsuarios/UsuariosService";

import { Controller } from "../../Controller";

export async function ListarUsuariosController() {
    return Controller(ListarUsuariosService());
}

export async function ListarUsuariosGrupoController(grupo: boolean) {
    return Controller(ListarUsuariosGrupoService(grupo));
}

export async function ListarUsuariosMesmoProdutoController() {
    return Controller(ListarUsuariosMesmoProdutoService());
}

export async function GetUsuarioInfoController(idUsuario: number) {
    return Controller(GetUsuarioInfoService(idUsuario));
}

export async function AtualizarUsuarioController(
    requestBody: AtualizarUsuarioInterface,
    idUsuarioCopia?: number
) {
    return Controller(AtualizarUsuarioService(requestBody, idUsuarioCopia));
}

export async function DeletarUsuarioController(idUsuario: number) {
    return Controller(DeletarUsuarioService(idUsuario));
}

export async function ListarUsuariosTransferenciaController(
    requestBody: IListaUsuariosTransferencias
) {
    return Controller(ListarUsuariosTransferenciaService(requestBody));
}
